import { jsxs, jsx } from "react/jsx-runtime";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
import { Dialog as Pt, DialogBackdrop as ct, DialogPanel as $e, DialogTitle as je } from "../../../external/@headlessui/react/dist/components/dialog/dialog.js";
function Dialog({
  open,
  onClose,
  transition = false,
  title,
  children,
  className,
  classes,
  zIndex = 10
}) {
  const { themeClasses } = useThemePresetClasses("Dialog", classes, className);
  return /* @__PURE__ */ jsxs(
    Pt,
    {
      open,
      onClose,
      className: cn(themeClasses == null ? void 0 : themeClasses.root),
      children: [
        /* @__PURE__ */ jsx(
          ct,
          {
            className: cn(themeClasses == null ? void 0 : themeClasses.backDrop),
            transition,
            style: {
              zIndex
            }
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(themeClasses == null ? void 0 : themeClasses.containerWrapper),
            style: {
              zIndex: zIndex + 1
            },
            children: /* @__PURE__ */ jsxs(
              $e,
              {
                transition,
                className: cn(themeClasses == null ? void 0 : themeClasses.container),
                style: {
                  zIndex: zIndex + 2
                },
                children: [
                  typeof title === "string" ? /* @__PURE__ */ jsx(je, { className: cn(themeClasses == null ? void 0 : themeClasses.title), children: title }) : title,
                  children
                ]
              }
            )
          }
        )
      ]
    }
  );
}
export {
  Dialog as default
};
